export default __webpack_public_path__ + "static/media/1754.7f5f09c2.png";